export default "__VITE_ASSET__DAvuieFM__"